import * as Sentry from '@sentry/react';
import { getClasslinkInformation, handleClassLinksUserInfo, handleUserClassesSync } from 'store/classlink/thunks';
import { handleLoginWithToken } from 'store/auth/thunks';
import { has } from 'lodash';

export const handleClasslinkAuth = async ({
    search,
    setIsAutoLogin,
    setError,
    loginWithSchoology,
    setLoading,
    setAutologinMessage,
    dispatch
}) => {
    setLoading(true);
    setIsAutoLogin(true);
    try {
        if (typeof search.code !== "string") {
            setAutologinMessage("Invalid code. Please try again or contact support for assistance.");
            setError("Invalid code. Please try again or contact support for assistance.");
            setLoading(false);
            setIsAutoLogin(false);
            Sentry.captureException(`591-classlink-a Invalid code. Please try again or contact support for assistance.`);
            return;
        }
        const data = await getClasslinkInformation(search.code);
        if (has(data, "SourcedId")) {
            const { SourcedId, TenantId, token, userData } = data;
            let payload = data;
            let tokenToUse = token;
            if (!tokenToUse && SourcedId && TenantId) {
                const userDataFromApi = await handleClassLinksUserInfo(SourcedId, TenantId);
                if (userDataFromApi && !userDataFromApi.error) {
                    tokenToUse = userDataFromApi.token;
                    payload = userDataFromApi;
                }
            }
            if (tokenToUse && dispatch) {
                const result = await dispatch(handleLoginWithToken(tokenToUse));
                if (!result || !result.isSignedIn) {
                    setAutologinMessage('Authentication failed. Please try login again!');
                    setError('Authentication failed. Please try login again!');
                    setLoading(false);
                    setIsAutoLogin(false);
                    return;
                }
                await handleUserClassesSync(SourcedId, TenantId);
                const loginPayload = (payload.userData ? { ...payload.userData, username: result.username } : payload) || { username: result.username };
                await loginWithSchoology(loginPayload);
                setLoading(false);
                setIsAutoLogin(false);
            } else if (!tokenToUse) {
                Sentry.captureException(`591-classlink-b Error in handleCode while fetching user data: ${typeof data === "object" ? JSON.stringify(data) : data}`);
                setAutologinMessage("Unable to register the user with the provided code. Please try again.");
                setError("Unable to register the user with the provided code. Please try again.");
                setLoading(false);
                setIsAutoLogin(false);
            }
        } else {
            Sentry.captureException(`591-classlink-c Error in handleCode while fetching user data: ${typeof data === "object" ? JSON.stringify(data) : data}`);
            setAutologinMessage("Unable to fetch the user with the provided code. Please try again.");
            setError("Unable to fetch the user with the provided code. Please try again.");
            setLoading(false);
            setIsAutoLogin(false);
        }
    } catch (error) {
        Sentry.captureException(`591-classlink-d Error in handleCode: ${typeof error === "object" ? JSON.stringify(error) : error}`);
        setAutologinMessage("Unable to fetch the user with the provided code. Please try again.");
        setError("Unable to fetch the user with the provided code. Please try again.");
    } finally {
        setLoading(false);
        setIsAutoLogin(false);
    }
};
